module.exports = "/assets/data/6f2a24eb310f855d95af29ce97e26187-ST11.data.json";